
export const OPEN = 'OPEN'
export const CLOSING = 'CLOSING'
export const CLOSED = 'CLOSED'
